import { useEffect, useMemo, useState } from 'react';
import GlobalTable from '../../../../components/CustomTableWithPagination/GlobalTable';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
import { inactiveStudentDataAnalytcsTableHead } from './utils/inactiveStudentDataAnalytics';
import { Stack } from '@mui/material';
import FromAndToDatePicker from '../../../../components/mui/FromAndToDatePicker';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { getInactiveStudentDataAnalytcsTable } from '../../../../redux/features/crdMigrationSlice';
import dayjs from 'dayjs';

export default function InactiveStudentDataAnalytcs() {
  // normal variable
  const dispatch = useDispatch();

  /***********************************************/

  // react state
  const [fromDate, setFromDate] = useState(dayjs().startOf('year').format('YYYY-MM-DD'));
  const [toDate, setToDate] = useState(dayjs().endOf('year').format('YYYY-MM-DD'));
  const [tableState, setTableState] = useState({
    page: 1,
    pageSize: 50,
    search: '',
  });
  /***********************************************/

  // redux state

  const inactiveStudentDataAnalytcsTable = useSelector(
    (state) => state.crdMigration.inactiveStudentDataAnalytcsTable.data,
  );
  const loading = useSelector((state) => state.crdMigration.inactiveStudentDataAnalytcsTable.loading);
  const meta = useSelector((state) => state.crdMigration.inactiveStudentDataAnalytcsTable.meta);

  /***********************************************/

  // dispatch Params
  const dispatchParams = useMemo(
    () => ({
      page: tableState?.page,
      limit: tableState?.pageSize,
      search: tableState?.search,
      fromDate: fromDate,
      toDate: toDate,
    }),
    [tableState, fromDate, toDate],
  );

  /***********************************************/

  // mounting Fetch
  useEffect(() => {
    dispatch(getInactiveStudentDataAnalytcsTable(dispatchParams));
  }, [dispatch, dispatchParams]);

  /***********************************************/
  return (
    <GlobalWrapper title={'Inactive Students Data Analytics'}>
      <Stack gap={1}>
        <FromAndToDatePicker fromDate={fromDate} setFromDate={setFromDate} toDate={toDate} setToDate={setToDate} />
        <GlobalTable
          headers={inactiveStudentDataAnalytcsTableHead}
          rows={[]}
          tableState={tableState}
          setTableState={setTableState}
          loading={loading}
        />
      </Stack>
    </GlobalWrapper>
  );
}
